import { FC } from 'react'
import { Modal } from 'react-bootstrap'

import InfoCardRowForm from './info-card-row-form'
import { Button } from '../button'

import { IInfoCardRowFormValues, IInfoCardRowUpsertFormValues } from '../form'
import { IEditHistory } from './info-card-types'

import s from './info-card.module.scss'
import { renderLocalDate } from '../../util'

type UpdateInfoCardRowModalProps = {
  onSave: (values: IInfoCardRowFormValues) => void
  isOpen: boolean
  closeModal: () => void
  initialValues?: IInfoCardRowUpsertFormValues
  label: string
  options: string[]
  editHistory?: IEditHistory | null
}

const UpdateInfoCardRowModal: FC<UpdateInfoCardRowModalProps> = props => {
  const { isOpen, closeModal, onSave, initialValues, label, options, editHistory} = props

  return (
    <Modal animation={false} onHide={closeModal} show={isOpen} centered contentClassName="h-100">
      <Modal.Header closeButton={true}>
        <Modal.Title>Update Internal Response</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <InfoCardRowForm 
          onSubmit={onSave} 
          initialValues={initialValues} 
          formName="info-card-row" 
          label={label} 
          options={options} 
        />

        {editHistory && (
          <div className="mt-3">
            <div className={s['info-history-section']}>
              <div className={s['title']}>Edit History</div>
              <div className={`${s.item} ${s.original}`}>
                  <strong>{editHistory.original.label}:</strong> {editHistory.original.value}
                  <div className={s['timestamp']}>{renderLocalDate(editHistory.original.dateTime)}</div>
              </div>
              <div className={`${s.item} ${s.modified}`}>
                  <strong>{editHistory.modified.label}:</strong> {editHistory.modified.value}
                  <div className={s['timestamp']}>By {editHistory.modified.modifiedBy}, {renderLocalDate(editHistory.modified.modifiedAt)}</div>
              </div>
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button type="secondary" buttonType="button" onClick={closeModal}>
          Cancel
        </Button>
        <Button type="primary" buttonType="submit" form="info-card-row">
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default UpdateInfoCardRowModal
